import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { AgGridModule } from 'ag-grid-angular';
import { NavigationComponent } from "./components/navigation/navigation.component";
import { AppRoutesModule } from "./routes.module";
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptors } from "@angular/common/http";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { HeaderComponent } from "./components/header/header.component";
import { LoginPageComponent } from "./page/login-page/login-page.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { NgxSmartModalModule } from "ngx-smart-modal";
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { PhonePipe } from './pipes/phone/phone.pipe';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SocialAuthServiceConfig, GoogleSigninButtonModule, GoogleLoginProvider } from '@abacritt/angularx-social-login';
import { environment } from 'src/environments/environment';
import { ApplicationsPageComponent } from './page/applications-page/applications-page.component';
import { SupplierPageComponent } from './page/supplier-page/supplier-page.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { EditSupplierDialogComponent } from './dialogs/edit-supplier-dialog/edit-supplier-dialog.component';
import { AuthInterceptor } from './interceptors/auth/auth.interceptor';
import { CreateSupplierDialogComponent } from './dialogs/create-supplier-dialog/create-supplier-dialog.component';
import { DeleteSupplierDialogComponent } from './dialogs/delete-supplier-dialog/delete-supplier-dialog.component';
import { CdkColumnDef } from '@angular/cdk/table';
import { ErrorInterceptor } from './interceptors/error/error.interceptor';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { GetTransactionsDialogComponent } from './dialogs/get-transactions-dialog/get-transactions-dialog.component';
import { GreenskyPageComponent } from './page/greensky-page/greensky-page.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CreditPlanPageComponent } from './page/credit-plan-page/credit-plan-page.component';
import { EditCreditPlanDialogComponent } from './dialogs/edit-credit-plan-dialog/edit-credit-plan-dialog.component';
import { CreateCreditPlanDialogComponent } from './dialogs/create-credit-plan-dialog/create-credit-plan-dialog.component';
import { HomePageComponent } from './page/home-page/home-page.component';
import { UsersPageComponent } from './page/users-page/users-page.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { PermissionGroupDialogComponent } from './dialogs/permission-group-dialog/permission-group-dialog.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BeyondSupplierPageComponent } from './page/beyond-supplier-page/beyond-supplier-page.component';
import { EditBeyondSupplierDialogComponent } from './dialogs/edit-beyond-supplier-dialog/edit-beyond-supplier-dialog.component';
import { SuspendBeyondSupplierDialogComponent } from './dialogs/suspend-beyond-supplier-dialog/suspend-beyond-supplier-dialog.component';
import { TerminateBeyondSupplierDialogComponent } from './dialogs/terminate-beyond-supplier-dialog/terminate-beyond-supplier-dialog.component';
import { TerminationPageComponent } from './page/termination-page/termination-page.component';
import { ApproveTerminationDialogComponent } from './dialogs/approve-termination-dialog/approve-termination-dialog.component';
import { ViewTerminationDialogComponent } from './dialogs/view-termination-dialog/view-termination-dialog.component';
import { ManualReviewPageComponent } from './page/manual-review-page/manual-review-page.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    CommonModule,
    AgGridModule,
    AppRoutesModule,
    HttpClientModule,
    NgxMaskDirective,
    NgxMaskPipe,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgxSmartModalModule.forRoot(),
    ToastrModule.forRoot(),
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    PhonePipe,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    GoogleSigninButtonModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    MatSelectModule,
    MatCheckboxModule,
  ],
  declarations: [
    AppComponent,
    NavigationComponent,
    LoginPageComponent,
    GreenskyPageComponent,
    HeaderComponent,
    ApplicationsPageComponent,
    SupplierPageComponent,
    EditSupplierDialogComponent,
    CreateSupplierDialogComponent,
    DeleteSupplierDialogComponent,
    GetTransactionsDialogComponent,
    EditCreditPlanDialogComponent,
    CreditPlanPageComponent,
    HomePageComponent,
    CreateCreditPlanDialogComponent,
    UsersPageComponent,
    PermissionGroupDialogComponent,
    BeyondSupplierPageComponent,
    EditBeyondSupplierDialogComponent,
    SuspendBeyondSupplierDialogComponent,
    TerminateBeyondSupplierDialogComponent,
    TerminationPageComponent,
    ApproveTerminationDialogComponent,
    ViewTerminationDialogComponent,
    ManualReviewPageComponent,
  ],
  providers: [
    provideNgxMask(),
    provideAnimationsAsync(),
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [{
          id: GoogleLoginProvider.PROVIDER_ID,
          provider: new GoogleLoginProvider(environment.googleClientID, { oneTapEnabled: false }),
        }],
        onError: (error: Error) => {
          console.error("[ERR]: error with google login provider", error);
        },
      } as SocialAuthServiceConfig,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    CdkColumnDef,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
